module.exports = __webpack_public_path__ + "img/PRNT_03_mono_AE_00005.17c5d137.png";